import {
  Component,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  RvDraggableService,
  RvDraggableItem,
  RvDroppableItem,
} from '../../services/rv-draggable.service';

@Component({
  selector: 'rv-draggable',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./rv-draggable.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'draggable-container',
    tabindex: '-1',
  },
  providers: [
    {
      provide: RvDraggableService,
      useFactory: (component: RvDraggableComponent) =>
        component.draggableService,
      deps: [RvDraggableComponent],
    },
  ],
})
export class RvDraggableComponent implements OnDestroy {
  @Input() draggableService: RvDraggableService<
    RvDraggableItem,
    RvDroppableItem
  >;

  constructor() {}

  ngOnDestroy() {
    if (this.draggableService) {
      this.draggableService.destroy();
    }
  }
}
